import { render } from "./InfoForm.vue?vue&type=template&id=4270292b"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__